import * as $ from 'jquery';
import { $body } from "Core/Body";
import { onClick, onLoad } from "Core/Events";
import { ActualScreen, Breakpoints } from 'Core/Responsiveness';
import "jquery.cookie";

export const PWAAvailableToInstallPopup = (() => {
    /** in milliseconds */
    const ANIMATION_DURATION = 250;
    const PWA_MESSAGE_COOKIE_KEY = 'pwa_message_seen_or_closed';
    const Selector = {
        POPUP: {
            ITSELF: '#pwa-install-popup',
            CLOSE_BTN: '#pwa-install-popup .close-btn',
            SHOW_INSTRUCTION_MODAL_BTN: '#pwa-install-popup #show-instruction-btn'
        },
        INSTRUCTION_MODAL: {
            ITSELF: '#pwa-install-instruction',
            CLOSE_BTN: '#pwa-install-instruction .close-btn'
        }
    }

    const Element = {
        POPUP: /* html */`
            <div id="pwa-install-popup">
            <small>
                Bodzio jest już dostępne w formie aplikacji mobilnej! 
            </small></br>
                <button type="button" class="btn btn-primary ml-3 mr-1 " data-toggle="modal" data-target="pwa-install-instruction" id="show-instruction-btn">Zainstaluj</button>
                <button class="mx-1 btn btn-outline close-btn">Zamknij</button>
            </div>
        `,
        INSTRUCTION_MODAL: /* html */`
            <div class="modal fade" id="pwa-install-instruction" tabindex="-1" role="dialog" aria-hidden="true"> 
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Pobierz aplikację Bodzio</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p>
                                <b>Dla iOS</b>: Wybierz ikonę
                                <img class="icon" src="/public/build/assets/images/ios-share-icon.svg" alt="ios-share-icon"/>
                                pod paskiem adresu i zapisz aplikację na stronie startowej klikając <img class="icon" src="/public/build/assets/images/ios-plus-icon.svg" alt="ios-plus-icon"/>

                                </br>
                                </br>

                                <b>Dla Androida</b>: Wybierz <img class="icon" src="/public/build/assets/images/android-3dots-icon.svg" alt="android-3dots-icon"/> 
                                i zapisz aplikację na stronie startowej klikając <img class="icon" src="/public/build/assets/images/android-add_to_home_screen-icon.svg" alt="android-add_to_home_screen-icon"/>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        `
    }

    // If you want to check how this module behaves step-by-step
    // then this is your entrypoint
    onLoad(async () => {
        const { canInstall } = await checkIfUserCanInstallWebsiteAsPWA();
        const didUserSeeThePWAMessageBefore = checkIfUserHasSeenTheMessageAboutPWA();

        if (canInstall && !didUserSeeThePWAMessageBefore && ActualScreen.WIDTH < Breakpoints.MD) {
            appendPopupWithInstallInstructionToDOM();
            togglePopupVisibility(true);
        }
    });
    // But there are also some other event handlers that do not require any specific flow
    onClick(Selector.POPUP.CLOSE_BTN, () => {
        saveUserSeenTheMessageAboutPWAToCookies();
        togglePopupVisibility(false)
    });
    onClick(Selector.POPUP.SHOW_INSTRUCTION_MODAL_BTN, () => {
        saveUserSeenTheMessageAboutPWAToCookies();
        toggleInstructionModalVisibility(true)
    });
    onClick(Selector.INSTRUCTION_MODAL.CLOSE_BTN, () => {
        saveUserSeenTheMessageAboutPWAToCookies();
        togglePopupVisibility(false);
        toggleInstructionModalVisibility(false);
    });

    function saveUserSeenTheMessageAboutPWAToCookies() {
        $.cookie(PWA_MESSAGE_COOKIE_KEY, 'true', { expires: 365 * 2, path: '/' });
    }

    function checkIfUserHasSeenTheMessageAboutPWA(): boolean {
        return Boolean($.cookie(PWA_MESSAGE_COOKIE_KEY));        
    }

    async function checkIfUserCanInstallWebsiteAsPWA(): Promise<{ canInstall: boolean }> {
        return new Promise(async (resolve) => {
            // Check if service workers are supported
            if (!('serviceWorker' in navigator)) {
                return resolve({ canInstall: false });
            }

            // Check if the manifest element is supported
            const linkElement = document.createElement('link');
            const supportsManifest = 'relList' in linkElement && linkElement.relList.supports('manifest');

            if (supportsManifest) {
                return resolve({ canInstall: true });
            }

            // Check for the beforeinstallprompt event (Chromium-based browsers)
            if ('onbeforeinstallprompt' in window) {
                return resolve({ canInstall: true });
            }

            return resolve({ canInstall: false });
        });
    }

    function appendPopupWithInstallInstructionToDOM() {
        $body.append(Element.POPUP);
        $body.append(Element.INSTRUCTION_MODAL);

        toggleInstructionModalVisibility(false);
    }

    function togglePopupVisibility(visible: boolean) {
        if (visible) $(Selector.POPUP.ITSELF).fadeIn({ duration: ANIMATION_DURATION });
        else $(Selector.POPUP.ITSELF).fadeOut({ duration: ANIMATION_DURATION });
    }

    function toggleInstructionModalVisibility(visible: boolean) {
        if (visible) $(Selector.INSTRUCTION_MODAL.ITSELF).modal({ keyboard: true, focus: true, show: true });
        else $(Selector.INSTRUCTION_MODAL.ITSELF).modal({ show: false });
    }
})();import * as $ from 'jquery';
import { $body } from "Core/Body";
import { onClick, onLoad } from "Core/Events";
import { ActualScreen, Breakpoints } from 'Core/Responsiveness';
import "jquery.cookie";

export const PWAAvailableToInstallPopup = (() => {
    /** in milliseconds */
    const ANIMATION_DURATION = 250;
    const PWA_MESSAGE_COOKIE_KEY = 'pwa_message_seen_or_closed';
    const Selector = {
        POPUP: {
            ITSELF: '#pwa-install-popup',
            CLOSE_BTN: '#pwa-install-popup .close-btn',
            SHOW_INSTRUCTION_MODAL_BTN: '#pwa-install-popup #show-instruction-btn'
        },
        INSTRUCTION_MODAL: {
            ITSELF: '#pwa-install-instruction',
            CLOSE_BTN: '#pwa-install-instruction .close-btn'
        }
    }

    const Element = {
        POPUP: /* html */`
            <div id="pwa-install-popup">
            <small>
                Bodzio jest już dostępne w formie aplikacji mobilnej! 
            </small></br>
                <button type="button" class="btn btn-primary ml-3 mr-1 " data-toggle="modal" data-target="pwa-install-instruction" id="show-instruction-btn">Zainstaluj</button>
                <button class="mx-1 btn btn-outline close-btn">Zamknij</button>
            </div>
        `,
        INSTRUCTION_MODAL: /* html */`
            <div class="modal fade" id="pwa-install-instruction" tabindex="-1" role="dialog" aria-hidden="true"> 
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Pobierz aplikację Bodzio</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p>
                                <b>Dla iOS</b>: Wybierz ikonę
                                <img class="icon" src="/public/build/assets/images/ios-share-icon.svg" alt="ios-share-icon"/>
                                pod paskiem adresu i zapisz aplikację na stronie startowej klikając <img class="icon" src="/public/build/assets/images/ios-plus-icon.svg" alt="ios-plus-icon"/>

                                </br>
                                </br>

                                <b>Dla Androida</b>: Wybierz <img class="icon" src="/public/build/assets/images/android-3dots-icon.svg" alt="android-3dots-icon"/> 
                                i zapisz aplikację na stronie startowej klikając <img class="icon" src="/public/build/assets/images/android-add_to_home_screen-icon.svg" alt="android-add_to_home_screen-icon"/>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        `
    }

    // If you want to check how this module behaves step-by-step
    // then this is your entrypoint
    onLoad(async () => {
        const { canInstall } = await checkIfUserCanInstallWebsiteAsPWA();
        const didUserSeeThePWAMessageBefore = checkIfUserHasSeenTheMessageAboutPWA();

        if (canInstall && !didUserSeeThePWAMessageBefore && ActualScreen.WIDTH < Breakpoints.MD) {
            appendPopupWithInstallInstructionToDOM();
            togglePopupVisibility(true);
        }
    });
    // But there are also some other event handlers that do not require any specific flow
    onClick(Selector.POPUP.CLOSE_BTN, () => {
        saveUserSeenTheMessageAboutPWAToCookies();
        togglePopupVisibility(false)
    });
    onClick(Selector.POPUP.SHOW_INSTRUCTION_MODAL_BTN, () => {
        saveUserSeenTheMessageAboutPWAToCookies();
        toggleInstructionModalVisibility(true)
    });
    onClick(Selector.INSTRUCTION_MODAL.CLOSE_BTN, () => {
        saveUserSeenTheMessageAboutPWAToCookies();
        togglePopupVisibility(false);
        toggleInstructionModalVisibility(false);
    });

    function saveUserSeenTheMessageAboutPWAToCookies() {
        $.cookie(PWA_MESSAGE_COOKIE_KEY, 'true', { expires: 365 * 2, path: '/' });
    }

    function checkIfUserHasSeenTheMessageAboutPWA(): boolean {
        return Boolean($.cookie(PWA_MESSAGE_COOKIE_KEY));        
    }

    async function checkIfUserCanInstallWebsiteAsPWA(): Promise<{ canInstall: boolean }> {
        return new Promise(async (resolve) => {
            // Check if service workers are supported
            if (!('serviceWorker' in navigator)) {
                return resolve({ canInstall: false });
            }

            // Check if the manifest element is supported
            const linkElement = document.createElement('link');
            const supportsManifest = 'relList' in linkElement && linkElement.relList.supports('manifest');

            if (supportsManifest) {
                return resolve({ canInstall: true });
            }

            // Check for the beforeinstallprompt event (Chromium-based browsers)
            if ('onbeforeinstallprompt' in window) {
                return resolve({ canInstall: true });
            }

            return resolve({ canInstall: false });
        });
    }

    function appendPopupWithInstallInstructionToDOM() {
        $body.append(Element.POPUP);
        $body.append(Element.INSTRUCTION_MODAL);

        toggleInstructionModalVisibility(false);
    }

    function togglePopupVisibility(visible: boolean) {
        if (visible) $(Selector.POPUP.ITSELF).fadeIn({ duration: ANIMATION_DURATION });
        else $(Selector.POPUP.ITSELF).fadeOut({ duration: ANIMATION_DURATION });
    }

    function toggleInstructionModalVisibility(visible: boolean) {
        if (visible) $(Selector.INSTRUCTION_MODAL.ITSELF).modal({ keyboard: true, focus: true, show: true });
        else $(Selector.INSTRUCTION_MODAL.ITSELF).modal({ show: false });
    }
})();